import React, { useState } from "react";
import styled from "@emotion/styled";
import BackHeader from "@components/header/BackHeader";
import { useTranslation } from "react-i18next";
import BasicButton from "@components/button/BasicButton";
import { useTheme } from "@emotion/react";
import SubscribeDetailCard from "@pages/myPage/_component/SubscribeDetailCard";
import CancelSubscribeDrawer from "@components/drawer/CancelSubscribeDrawer";
import BasicModal from "@components/modal/BasicModal";
import Image from "@components/item/Image";
import { useQuery } from "@tanstack/react-query";
import { useApiRequest } from "@utils/ApiRequest";
import TossBillingButton from "@pages/subscribe/TossBillingButton";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "2rem",
});

const InfoWrapper = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "1.2rem",
  padding: "2rem 2rem 0",
}));

const Title = styled.span(({ theme }) => ({
  fontSize: "2rem",
  fontWeight: theme.fontWeight.bold,
  color: theme.color.black,
  paddingBottom: "0.8rem",
}));

const InfoBox = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "1.6rem",
  color: theme.color.gray,
  fontWeight: theme.fontWeight.regular,
  padding: "1.6rem",
  border: `1px solid ${theme.color.light_gray}`,

  ".data": {
    color: theme.color.black,
    fontWeight: theme.fontWeight.medium,
  },
}));

const Flex = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  gap: "0.4rem",
  alignItems: "center",
}));

const Line = styled.div(({ theme }) => ({
  width: "100%",
  height: "1px",
  backgroundColor: theme.color.black,
  margin: "1.6rem 0",
}));

const ModalContent = styled.div({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "2rem",
  paddingBottom: "4.4rem",
});

const SubscribeDetail = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const { getMemberSubscription, getSubscriptionList } = useApiRequest();

  const { data: subscribeDetail } = useQuery({
    queryKey: ["subscribeDetail"],
    queryFn: () => getMemberSubscription(),
  });

  const { data: subscribeDetailList } = useQuery({
    queryKey: ["subscribeDetailList"],
    queryFn: () => getSubscriptionList(),
  });

  const handleOpenDrawer = () => {
    setOpen(true);
  };

  return (
    <Container>
      <BackHeader title="구독내역" />
      <InfoWrapper>
        <Title>{t("내 구독")}</Title>

        {subscribeDetail?.is_subscribed &&
          subscribeDetail?.status === "CANCELED" && (
            <InfoBox>
              <Flex>
                <span>결제금액</span>
                <span className="data">
                  월 {subscribeDetail?.amount?.toLocaleString()} {t("원")}
                </span>
              </Flex>

              <Flex>
                <span>다음 결제 날짜</span>
                <span className="data">
                  {subscribeDetail?.next_payment_date}
                </span>
              </Flex>
            </InfoBox>
          )}

        {subscribeDetail?.is_subscribed &&
        subscribeDetail?.status === "ACTIVE" ? (
          <BasicButton
            title="구독 취소하기"
            height="4.8rem"
            icon={theme.image.arrow_right_white.default}
            onClick={handleOpenDrawer}
          />
        ) : (
          <TossBillingButton
            icon={theme.image.arrow_right_white.default}
            title="구독 재신청하기"
          />
        )}

        <Line />
      </InfoWrapper>

      {subscribeDetailList?.map((item: any) => (
        <SubscribeDetailCard
          key={item?.id}
          paymentDate={item?.payment_date}
          amount={item?.amount}
          methodValue={item?.card_number}
        />
      ))}

      <CancelSubscribeDrawer
        open={open}
        setOpen={setOpen}
        setSuccessModal={setSuccessModal}
      />

      <BasicModal
        open={successModal}
        setOpen={setSuccessModal}
        notice
        activeEvent={() => setSuccessModal(false)}>
        <ModalContent>
          <Image
            src={theme.image.success_icon.default}
            width="4.8rem"
            height="4.8rem"
          />
          <span>취소되었습니다</span>
        </ModalContent>
      </BasicModal>
    </Container>
  );
};

export default SubscribeDetail;
